import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 6v4","key":"svg-0"}],["path",{"d":"M13 14h8q -2.518 -3 -4 -3","key":"svg-1"}],["path",{"d":"M13 6v9.958c0 .963 0 1.444 -.293 1.743s-.764 .299 -1.707 .299h-1","key":"svg-2"}],["path",{"d":"M7 6v9.958c0 .963 0 1.444 -.293 1.743s-.764 .299 -1.707 .299h-1","key":"svg-3"}]]

const IconAlphabetArabic = createReactComponent('outline', 'alphabet-arabic', 'AlphabetArabic', __iconNode);

export default IconAlphabetArabic;